var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#1FAB89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0835 9.0835H8.50016C8.19074 9.0835 7.894 9.20641 7.6752 9.4252C7.45641 9.644 7.3335 9.94074 7.3335 10.2502V15.5002C7.3335 15.8096 7.45641 16.1063 7.6752 16.3251C7.894 16.5439 8.19074 16.6668 8.50016 16.6668H13.7502C14.0596 16.6668 14.3563 16.5439 14.5751 16.3251C14.7939 16.1063 14.9168 15.8096 14.9168 15.5002V14.9168",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 7.91673L16.0833 9.66673M16.8912 8.84131C17.121 8.61157 17.2501 8.29997 17.2501 7.97506C17.2501 7.65016 17.121 7.33856 16.8912 7.10881C16.6615 6.87907 16.3499 6.75 16.025 6.75C15.7001 6.75 15.3885 6.87907 15.1588 7.10881L10.25 12.0001V13.7501H12L16.8912 8.84131Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileIcon);
export default __webpack_public_path__ + "static/media/edit-profile-icon.0f8cae725506794fe9091110ab3ec3a1.svg";
export { ForwardRef as ReactComponent };